var VJR_BANNER = VJR_BANNER || (function () {
    return {
        init: function (config) {
            const installParam = new URLSearchParams(window.location.search).get("installApp");

            // Redirect to app store if ?installApp=true is in URL
            if (installParam === "true") {
                const isAndroid = navigator.userAgent.includes("Android");
                const isIOS = /iPhone|iPad|iPod/.test(navigator.userAgent);

                if (isAndroid && config.android_package_name) {
                    window.location.href = `https://play.google.com/store/apps/details?id=${config.android_package_name}`;
                } else if (isIOS && config.ios_appid) {
                    window.location.href = `https://apps.apple.com/us/app/id${config.ios_appid}`;
                }
                return; // Stop further banner processing
            }

            if (this.getCookie("app_banner_dismissed") === "no") return;

            const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
            console.log("modal is aip", { isMobile }, config.title, config.days, config.image_url, config.appid, config.ios_appid, config.android_package_name);
            
            if (!isMobile || !config.title || !config.image_url || !config.appid || (!config.ios_appid && !config.android_package_name)) {
                return;
            }

            config.button_text = config.button_text || "INSTALL";

            // Inject CSS
            const style = document.createElement("style");
            style.type = "text/css";
            style.innerText = `
                .vjr-smart-banner { position: fixed; top: 0; left: 0; width: 100%; background: #fff; font-family: sans-serif; z-index: 999999; box-shadow: 0 2px 5px rgba(0,0,0,0.2); }
                .vjr-smart-banner-container { display: flex; align-items: center; padding: 10px; }
                .vjr-smart-banner-icon { width: 60px; height: 60px; background-image: url('${config.image_url}'); background-size: cover; border-radius: 10px; }
                .vjr-smart-banner-info { margin-left: 10px; flex: 1; }
                .vjr-smart-banner-title { font-weight: bold; font-size: 16px; }
                .vjr-smart-banner-subtitle { font-size: 12px; color: #666; }
                .vjr-smart-banner-button { background-color: ${config.button_color}; color: ${config.text_color}; padding: 8px 12px; border-radius: 4px; text-decoration: none; font-weight: bold; font-size: 14px; }
                .vjr-smart-banner-close { position: absolute; top: 10px; left: 10px; font-size: 18px; cursor: pointer; }
                .vjr-smart-banner-footer { text-align: center; font-size: 12px; color: gray; padding: 5px 0; }
            `;
            document.head.appendChild(style);

            // Create banner
            document.addEventListener("DOMContentLoaded", () => {
                const modal = document.createElement("div");
                modal.innerHTML = `
                    <div id="vjr-smart-banner-modal" class="vjr-smart-banner">
                        <div class="vjr-smart-banner-container">
                            <span class="vjr-smart-banner-close" onclick="VJR_BANNER.setCookie('app_banner_dismissed','no',${config.days}); VJR_BANNER.close();">&times;</span>
                            <div class="vjr-smart-banner-icon"></div>
                            <div class="vjr-smart-banner-info">
                                <div class="vjr-smart-banner-title">${config.title}</div>
                                <div class="vjr-smart-banner-subtitle">${config.sub_title || ""}</div>
                            </div>
                            <a href="/?installApp=true" target="_blank" class="vjr-smart-banner-button">${config.button_text}</a>
                        </div>
                        <div class="vjr-smart-banner-footer">Scroll down to continue in browser</div>
                    </div>
                `;
                

                // Auto open modal via hash
                setTimeout(() => {
                    // location.href = "/#vjr-smart-banner-modal";
                    document.body.appendChild(modal);
                    window.onscroll = function () {
                        if (document.body.scrollTop > 250 || document.documentElement.scrollTop > 250) {
                            // location.href = "/#!";
                            VJR_BANNER.close();
                        }
                    };
                }, 5000);
            });
        },

        close: function () {
            const banner = document.getElementById("vjr-smart-banner-modal");
            if (banner) {
                banner.remove(); // Remove banner from the DOM
            }
        },

        setCookie: function (name, value, days) {
            const d = new Date();
            d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
            document.cookie = `${name}=${value};expires=${d.toUTCString()};path=/`;
        },

        getCookie: function (name) {
            const nameEQ = name + "=";
            const ca = document.cookie.split(';');
            for (let c of ca) {
                while (c.charAt(0) === ' ') c = c.substring(1);
                if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
            }
            return "";
        }
    };
})();